import * as React from "react";
import {Alert, Form, Button, Container, Card} from "react-bootstrap";
import { Formik } from "formik";
import * as Yup from "yup";
import {connect} from "react-redux";
import withRequestState from "../../components/WithRequestState";
import { REGISTER_USER_REQUEST } from "../../redux/user/reducer";
import {registerCustomer} from "../../redux/user/action";
import {resetRequestState} from "../../redux/requests/action";
import { RequestStateProps } from "../../interfaces/RequestState";
import { withRouter, RouteComponentProps } from "react-router-dom";
import {Link} from "react-router-dom";


interface IProps {
    registerCustomer: (name: string, email:string, password: string, company: string) => void;
    resetRequestState: () => void;
}

class registerPage extends React.Component<IProps & RequestStateProps & RouteComponentProps> {

    componentDidUpdate(){
        if (this.props.isSuccessful){
            this.props.resetRequestState();
            this.props.history.push("/login");
        }
    }

    render(){
        return (
            <Container>


                <Card className="mt-3">

                    <Card.Header>
                        <h1>Register</h1>
                    </Card.Header>

                    <Card.Body>

                        <Formik
                            initialValues={{
                                company: "",
                                name: "",
                                email: "",
                                password: "",
                                confirmPassword: ""
                            }}
                            validationSchema={
                                Yup.object().shape({
                                    name: Yup.string().required().min(1),
                                    company: Yup.string().required("Company name is required").min(3),
                                    email: Yup.string().required("Email is required"),
                                    password: Yup.string().required("Password is required").min(8),
                                    confirmPassword: Yup.string().required("Confirm password is required").oneOf([Yup.ref("password")], "Passwords don't match").min(8)
                                })
                            }
                            onSubmit={({name, email, password, company}) => {
                                this.props.registerCustomer(name, email, password, company);
                            }}
                        >
                            {(props) => (
                                <Form onSubmit={props.handleSubmit} noValidate>
                                    <Form.Group>
                                        <Form.Label>Company name</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="company"
                                            value={props.values.company}
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                            required={true}
                                            isInvalid={!!props.errors.company}
                                        />
                                         <Form.Control.Feedback type="invalid">
                                            {props.errors.company}
                                        </Form.Control.Feedback>
                                    </Form.Group>

                                    <h4>User account</h4>

                                    <Form.Group>
                                        <Form.Label>Name</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="name"
                                            value={props.values.name}
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                            isInvalid={!!props.errors.name}
                                            required={true}
                                        />
                                         <Form.Control.Feedback type="invalid">
                                            {props.errors.name}
                                        </Form.Control.Feedback>
                                    </Form.Group>

                                    <Form.Group>
                                        <Form.Label>Email</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="email"
                                            value={props.values.email}
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                            isInvalid={!!props.errors.email}
                                            required={true}
                                        />
                                         <Form.Control.Feedback type="invalid">
                                            {props.errors.email}
                                        </Form.Control.Feedback>
                                    </Form.Group>

                                    <Form.Group>
                                        <Form.Label>Password</Form.Label>
                                        <Form.Control
                                            type="password"
                                            name="password"
                                            value={props.values.password}
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                            isInvalid={!!props.errors.password}
                                            required={true}
                                        />
                                         <Form.Control.Feedback type="invalid">
                                            {props.errors.password}
                                        </Form.Control.Feedback>
                                    </Form.Group>

                                    
                                    <Form.Group>
                                        <Form.Label>Confirm password</Form.Label>
                                        <Form.Control
                                            type="password"
                                            name="confirmPassword"
                                            value={props.values.confirmPassword}
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                            isInvalid={!!props.errors.confirmPassword}
                                            required={true}
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            {props.errors.confirmPassword}
                                        </Form.Control.Feedback>
                                    </Form.Group>

                                    {
                                        this.props.hasError ? 
                                            <Alert variant="danger">
                                                Something failed...
                                            </Alert> : null
                                    }


                                    <Button variant="primary" type="submit">
                                        Register
                                    </Button>


                                    <Alert variant="info" className="mt-3 d-flex align-items-center">
                                        <i className="material-icons pr-2">info</i>
                                        Already have an account? click <Link to="/login" className="mx-1">here</Link> to login.
                                    </Alert>
                                </Form>
                            )}
                        </Formik>
                    </Card.Body>
                </Card>
            </Container>
        )
    }

}

export default withRouter(connect(null, ({
    registerCustomer,
    resetRequestState
}))(withRequestState(registerPage, [REGISTER_USER_REQUEST])));